export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_q04_b.a0fd4e6f.png";